import usergr from "../../../assets/images/HomeBring/usergr.svg";
import bookop from "../../../assets/images/HomeBring/bookop.svg";
import analy from "../../../assets/images/HomeBring/analy.svg";
import time4 from "../../../assets/images/HomeBring/time4.svg";
import medal from "../../../assets/images/HomeBring/medal.svg";
import aim from "../../../assets/images/HomeBring/aim.svg";
export default function HomeBring() {
  return (
    <div className="w-full">
      <div className="w-full mx-auto container py-[50px] flex flex-col gap-4 px-[20px]">
        <div className=" gap-2 w-full px-[20px] ">
          <p className="text-[24px] md:text-[32px] text-[#053CC8] font-semibold text-center mt-3">
            BLUERISE MANG LẠI GÌ CHO TRUNG TÂM CỦA BẠN
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 items-center justify-center w-full gap-[30px]">
          <div className="border border-[#CDD8F4] bg-[#F4F8FF] w-full h-[108px] px-[12px] rounded-[8px] flex flex-col items-center justify-center gap-3">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-postc">
              <img src={usergr} alt="us" />
            </div>
            <div className="text-[15px] md:text-[16px]">
              Tinh gọn bộ máy, nhân sự
            </div>
          </div>
          <div className="border border-[#CDD8F4] bg-[#F4F8FF] w-full h-[108px] px-[12px] rounded-[8px] flex flex-col items-center justify-center gap-3">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-postc">
              <img src={bookop} alt="book" />
            </div>
            <div className="text-[15px] md:text-[16px]">
              Quản trị chất lượng đào tạo
            </div>
          </div>
          <div className="border border-[#CDD8F4] bg-[#F4F8FF] w-full h-[108px] px-[12px] rounded-[8px] flex flex-col items-center justify-center gap-3">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-postc">
              <img src={analy} alt="ana" />
            </div>
            <div className="text-[15px] md:text-[16px]">
              Tăng năng suất nhân sự
            </div>
          </div>
          <div className="border border-[#CDD8F4] bg-[#F4F8FF] w-full h-[108px] px-[12px] rounded-[8px] flex flex-col items-center justify-center gap-3">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-postc">
              <img src={time4} alt="time" />
            </div>
            <div className="text-[15px] md:text-[16px]">
              Tiết kiệm thời gian, chi phí vận hành
            </div>
          </div>
          <div className="border border-[#CDD8F4] bg-[#F4F8FF] w-full h-[108px] px-[12px] rounded-[8px] flex flex-col items-center justify-center gap-3">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-postc">
              <img src={medal} alt="us" />
            </div>
            <div className="text-[15px] md:text-[16px]">
              Nâng cao giá trị thương hiệu với khách hàng
            </div>
          </div>
          <div className="border border-[#CDD8F4] bg-[#F4F8FF] w-full h-[108px] px-[12px] rounded-[8px] flex flex-col items-center justify-center gap-3">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-postc">
              <img src={aim} alt="us" />
            </div>
            <div className="text-[15px] md:text-[16px]">
              Dữ liệu phù hợp tích hợp AI
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
